import reducer from './reducers';
import * as sixthFlowsActions from './actions';
import * as sixthFlowsSelectors from './selectors';

export { sixthFlowsActions, sixthFlowsSelectors };
export default reducer;